(function($) {

	'use strict';

	function init(){
        scrollTop()
        manageStickyAccess()
        // managePopupAuth()
        openThrreeColBloc()
		accordionButtons()
	};

    function scrollTop(){

        $('.scrollTop').click(function(){
            window.scrollTo(0, 0);
        })

    }

    function manageStickyAccess(){

        $('.stickyAccess__btn').click(function(){
            $('.stickyAccess').toggleClass('active')
        })

        $('.stickyAccess__content__close').click(function(){
            $('.stickyAccess').removeClass('active')
        })

    }

    // function managePopupAuth(){

    //     $('.privateSpace').click(function(){
    //         $('.popupAuth').toggleClass('active')
    //         $('body').toggleClass('popupAuthActive')
    //     });
	// 	$('.popupAuth').on('click', function(e){
	// 		if( $(e.target).is( $(e.currentTarget) ) ){
	// 			$('.popupAuth').removeClass('active')
	// 			$('body').removeClass('popupAuthActive')
	// 		}
	// 	})

    // }

	function openThrreeColBloc(){

		$('.threeColsBloc__more').click(function(){
            $(this).addClass('active')

            $(this).siblings('.threeColsBloc__list').find('.threeColsBloc__item').addClass('active')

        })

	}

    function accordionButtons(){
		const buttons = document.getElementsByClassName('accordion-toggle');
		if(buttons){
			for(const button of buttons) {
				const accordionId = button.dataset.accordion;
				if( accordionId ){
					const accordion = document.getElementById(accordionId);
					if( accordion ){
						button.addEventListener('click', e => {
							const buttonActiveTxt = button.dataset.activeTxt;
							const buttonInactiveTxt = button.dataset.inactiveTxt;
							accordion.classList.toggle('active');
							button.classList.toggle('active');
							button.blur();
							if( accordion.classList.contains('active') ){
								accordion.style.maxHeight = accordion.scrollHeight + "px";
							} else {
								accordion.style.maxHeight = "";
							}
							if( buttonActiveTxt && buttonInactiveTxt ){
								const buttonTxt = button.classList.contains('active') ? buttonActiveTxt : buttonInactiveTxt;
								button.innerText = buttonTxt;
							}
						})
					}
				}
			}
		}
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);
